(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-comscore"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-comscore"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-plugin-comscore.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-plugin-comscore.js":
/*!*************************************!*\
  !*** ./src/mggp-plugin-comscore.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mggpPlayer = __webpack_require__(/*! mggp-player */ "mggp-player");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The base URL to communicate with the comScore metrix server.
 * It depends on the protocol which is specified in the origin server URL
 * @type {String}
 */
var SCRIPT_URL = 'https://s9.vcdn.biz/static/47558161/comscore.streaming.6.1.0.170130.min.js';

/**
 * @class MggpPluginComScore
 */

var MggpPluginComScore = function (_Plugin) {
	_inherits(MggpPluginComScore, _Plugin);

	/**
  * @constructor
  */
	function MggpPluginComScore() {
		var _ref;

		_classCallCheck(this, MggpPluginComScore);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		var _this = _possibleConstructorReturn(this, (_ref = MggpPluginComScore.__proto__ || Object.getPrototypeOf(MggpPluginComScore)).call.apply(_ref, [this].concat(args)));

		if (_this.config['comscore']) {
			_this._streamingAnalytics = null;
			_this.namespace = 'comscore:';
			_this._memberStarted = false;
			_this._onAdMemberComplete = _this._onAdMemberComplete.bind(_this);
			_this._onAdStarted = _this._onAdStarted.bind(_this);
			_this._onStateChange = _this._onStateChange.bind(_this);
			_this._load();
		}
		return _this;
	}

	_createClass(MggpPluginComScore, [{
		key: 'dispose',
		value: function dispose() {
			this._toggleListeners(false);
			this._memberStarted = false;
		}

		/**
   * Load the comScore library if not already loaded
   * @method
   */

	}, {
		key: '_load',
		value: function _load() {
			if ('ns_' in window && ns_.ReducedRequirementsStreamingAnalytics) {
				this._init();
			} else {
				var script = document.createElement('script');
				script.addEventListener('error', this._error.bind(this));
				script.addEventListener('load', this._init.bind(this));
				script.src = SCRIPT_URL;
				document.head.appendChild(script);
			}
		}
	}, {
		key: '_init',
		value: function _init() {
			this._streamingAnalytics = new ns_.ReducedRequirementsStreamingAnalytics({ publisherId: this.player.config.comscore.id });
			this._toggleListeners(true);
		}

		/**
   * Handle essential player events
   * @method
   */

	}, {
		key: '_toggleListeners',
		value: function _toggleListeners(add) {
			if (add) {
				this.player.on('ad:external:memberStartedPlaying', this._onAdStarted);
				this.player.on('ad:blockMember:complete', this._onAdMemberComplete);
				this.player.on('player:stateChange', this._onStateChange);
			} else {
				this.player.off('ad:external:memberStartedPlaying', this._onAdStarted);
				this.player.off('ad:blockMember:complete', this._onAdMemberComplete);
				this.player.off('player:stateChange', this._onStateChange);
			}
		}
	}, {
		key: '_onAdMemberComplete',
		value: function _onAdMemberComplete(event) {
			if (this._memberStarted) {
				this._memberStarted = false;
				this._streamingAnalytics.stop();
			}
		}
	}, {
		key: '_onStateChange',
		value: function _onStateChange() {
			var state = this.player.get('state');
			var videoInfo = this.player.get('videoInfo');
			var metadata = {
				ns_st_ci: videoInfo.video_id,
				ns_st_cl: 0,
				ns_st_pu: 'mgg',
				ns_st_pr: videoInfo.title,
				ns_st_ep: '',
				ns_st_sn: 0,
				ns_st_en: 0,
				ns_st_ge: '',
				ns_st_ddt: '',
				ns_st_st: ''
			};
			switch (state) {
				case 1:
					this._streamingAnalytics.playVideoContentPart(metadata, ns_.ReducedRequirementsStreamingAnalytics.ContentType.LongFormOnDemand);
					break;
				case 2:
				case 0:
					this._streamingAnalytics.stop();
					break;
			}
		}

		/**
   * Handle ad start
   * @param  {number} number current ad state
   */

	}, {
		key: '_onAdStarted',
		value: function _onAdStarted(event) {
			this._memberStarted = true;
			this._fire(event.data.type.toLowerCase());
		}

		/**
   * Fire tag
   * @method
   * @param  {Object} tag Values of tag to fire
   */

	}, {
		key: '_fire',
		value: function _fire(adType) {
			var type = '';
			switch (adType) {
				case 'preroll':
					type = ns_.ReducedRequirementsStreamingAnalytics.AdType.LinearOnDemandPreRoll;
					break;
				case 'midroll':
					type = ns_.ReducedRequirementsStreamingAnalytics.AdType.LinearOnDemandMidRoll;
					break;
				case 'postroll':
					type = ns_.ReducedRequirementsStreamingAnalytics.AdType.LinearOnDemandPostRoll;
					break;
				default:
					type = ns_.ReducedRequirementsStreamingAnalytics.AdType.Other;
					break;
			}

			this._streamingAnalytics.playVideoAdvertisement({
				ns_st_cl: this.player.get('ad:vendor:duration') * 1000 || 0
			}, type);
		}

		/**
   * Wrap the errors up into the MggpPluginComScoreError error type.
   * @param  {string} message error message
   */

	}, {
		key: '_error',
		value: function _error(message) {
			if (message instanceof Error) {
				message = message.message;
			}
			this.emit('error', new _mggpPlayer.AddonError(this.player, '', '', 'Cannot load comscore script from url ' + SCRIPT_URL));
		}
	}]);

	return MggpPluginComScore;
}(_mggpPlayer.Plugin);

exports.default = MggpPluginComScore;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});